import { Article } from '@wix/answers-api';
import { ArticleSearchResultDocumentType } from '@wix/cc-user-facing-common-components';

import {
  ArticleSearchResultItem,
} from '../../types';

export const normalizeArticle = (article: Article): ArticleSearchResultItem => {
  const {
    id,
    title,
    content,
    uri,
    url,
    type,
    categoryId,
    resolution,
    resolutionEta,
    labels = [],
    readingTimeInMinutes,
    creationDate,
  } = article as unknown as Article;
  return {
    id,
    title,
    description: content,
    uri,
    url,
    type,
    categoryId,
    labels,
    resolution,
    resolutionEta: resolutionEta && Number(resolutionEta),
    readingTimeInMinutes,
    creationDate,
    docType: ArticleSearchResultDocumentType.ANSWERS_ARTICLE,
  };
};
